import React, { createContext, useContext, useMemo, useState, useCallback, useEffect } from 'react';

const ToastContext = createContext(null);

export const useToast = () => {
    const ctx = useContext(ToastContext);
    if (!ctx) throw new Error('useToast must be used within ToastProvider');
    return ctx;
};

export default function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);

    const remove = useCallback((id) => setToasts((t) => t.filter((x) => x.id !== id)), []);

    const show = useCallback((message, opts = {}) => {
        const id = Math.random().toString(36).slice(2);
        const toast = { id, message, type: opts.type || 'info', duration: opts.duration ?? 3000 };
        setToasts((t) => [...t, toast]);
        if (toast.duration > 0) {
            setTimeout(() => remove(id), toast.duration);
        }
        return id;
    }, [remove]);

    const value = useMemo(() => ({ show, remove }), [show, remove]);

    return (
        <ToastContext.Provider value={value}>
            {children}
            <div className="fixed top-4 right-4 z-50 space-y-2">
                {toasts.map((t) => (
                    <div key={t.id} className={`rounded-md shadow px-4 py-2 text-sm text-white ${t.type === 'error' ? 'bg-red-600' : t.type === 'success' ? 'bg-green-600' : 'bg-gray-800'}`}>
                        {t.message}
                    </div>
                ))}
            </div>
        </ToastContext.Provider>
    );
}
